import { datadogLogs, Logger } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { getRuntimeEnvironment } from './getRuntimeEnvironment';

const isProductionBuild = import.meta.env.MODE === 'production';
const environment = getRuntimeEnvironment();

if (isProductionBuild) {
  datadogLogs.init({
    clientToken:
      environment === 'production'
        ? 'pub9261def376866274b6f8dd2110e956af'
        : 'pub2c8313b495a7561771cb5b194d2f2503',
    site: 'datadoghq.com',
    service: 'partner-branded-signup',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    version: import.meta.env.VITE_RELEASE,
  });

  datadogRum.init({
    applicationId:
      environment === 'production'
        ? 'e0dec811-ec68-4f36-859e-577d02a711f9'
        : '3768eb32-cd8a-4ecf-b373-84ee4636b419',
    clientToken:
      environment === 'production'
        ? 'pub40fa89f55e6ea6a18fc3b03f385b1e80'
        : 'pub5d8c4b3f680f77265f69b13dbce1a4aa',
    site: 'datadoghq.com',
    service: 'partner-branded-signup',
    version: import.meta.env.VITE_RELEASE,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: true })],
  });
}

export default (isProductionBuild
  ? datadogLogs.logger
  : { ...console }) as Logger;
